export default {
  CURTAIN_ACTION_EO_TITLE: 'Er du sikker på at du vil avbryte?',
  CURTAIN_ACTION_EO_DESCRIPTION:
    'Sven kjem til å sakne deg. Arbeidet ditt vil bli lagra.',
  CURTAIN_ACTION_EO_CANCEL: 'Ja',
  CURTAIN_ACTION_EO_SUBMIT: 'Nei',
  CURTAIN_ACTION_SUBMIT: 'Fortsette',
  CURTAIN_ACTION_CANCEL: 'Avbryt',
  CURTAIN_FEEDBACK_TITLE: 'Takk!',
  CURTAIN_FEEDBACK_DESCRIPTION:
    'No forstår eg korleis vi bruker språklege demparar for å uttrykke høflegheit.',
  CURTAIN_FEEDBACK_NEXT: 'Fortsette',
  CURTAIN_FEEDBACK_BACK: 'Tilbake',
  CURTAIN_FEEDBACK_BOX_TITLE: 'Vil du fortsette?',
  CURTAIN_ACTION_RACTIVITY_TITLE: 'Nullstille {title}?',
  CURTAIN_ACTION_RACTIVITY_DESCRIPTION:
    'For at du skal kunne løyse oppgåvene på nytt, må vi slette svara dine i Heim til middag. Ønsker du å nullstille?',
  CURTAIN_ACTION_RACTIVITY_SUBMIT: 'Nullstill oppgåver',
  CURTAIN_LANG_SELECT_TITLE: 'Vel målform',
  CURTAIN_LANG_SELECT_DESCRIPTION:
    'Før du begynner, må du velje målform.<br/>Du kan endre dette seinare.',
  CURTAIN_LANG_SELECT_SAVE: 'Lagre',
  CURTAIN_LANG_SWITCH_TITLE: 'Skift målform',
  CURTAIN_LANG_SWITCH_DESCRIPTION: '',
  CURTAIN_LANG_SWITCH_SAVE: 'Lagre',
}
